/**
 * 与 CommonUpload 一致的 STS + OSS multipartUpload；返回公网 URL 与对象路径（uri）。
 */
const OSS = require('ali-oss')

function buildClient(res) {
  const region = res.endpoint
  const fKey = region.indexOf('//') + 2
  const lKey = region.indexOf('.')
  return new OSS({
    region: region.substring(fKey, lKey),
    accessKeyId: res.accessKeyId,
    accessKeySecret: res.accessKeySecret,
    stsToken: res.securityToken,
    bucket: res.bucketName,
  })
}

function buildPublicUrl(res, objectKey, result) {
  const endpointPath = res.endpoint.split('/')
  const endpoint = endpointPath[endpointPath.length - 1]
  const name = (result && result.name) ? result.name : objectKey
  if (result && result.url) {
    return result.url
  }
  return `https://${res.bucketName}.${endpoint}/${name}`
}

/**
 * @param {File|Blob} file
 */
export function extFromImageMime(file) {
  const t = file.type || ''
  if (t === 'image/jpeg') return 'jpg'
  if (t === 'image/png') return 'png'
  return 'png'
}

/**
 * 与 CommonUpload.beforeUpload 一致：仅 JPG/PNG，小于 2MB。
 * @param {File|Blob} file
 */
export function validateJpgPngMax2M(file) {
  const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
  if (!isJpgOrPng) {
    return { ok: false, message: '只能上传图片文件!' }
  }
  const isLt2M = file.size / 1024 / 1024 < 2
  if (!isLt2M) {
    return { ok: false, message: '文件必须小于2MB!' }
  }
  return { ok: true }
}

/** @param {*} ossApi OssApi 实例 */
export async function uploadImageMultipart(ossApi, file, path, nameBase) {
  const ext = extFromImageMime(file)
  const res = await ossApi.getStsAkV2(path)
  const client = buildClient(res)
  const objectKey = `${res.url}${nameBase}.${ext}`
  const result = await client.multipartUpload(objectKey, file)
  const url = buildPublicUrl(res, objectKey, result)
  return { url, uri: objectKey }
}
